import React, { createContext, useContext, useState, useMemo, useEffect } from 'react';
import { saveReferrerIfNotSet } from '../services/CookieHandler';
const RefererContext = createContext({
  referer: '',
});

export const useReferer = () => useContext(RefererContext);

export const RefererProvider = ({ children }: { children: React.ReactNode }) => {
  const [referer, setReferer] = useState('');

  useEffect(() => {
    saveReferrerIfNotSet();
  }, []);

  return <>
    <RefererContext.Provider value={{ referer }}>
      {children}
    </RefererContext.Provider>
  </>;
};
